import { ModelBase } from 'store/model-base';

export class CmsOrderDetail extends ModelBase {
    public static storeName: string = 'cmsOrderDetail';

    public header: string;
    public preOrder: string;
    public cancelLabel: string;
    public upgradeLabel: string;
    public upgradeHeader: string;
    public upgradeDescription: string;
    public cancelMessage: string;
    public checkmarkIcon: CmsMediaOptionsImage;
    public orderStatus: CmsOrderStatus;
    public backOrderDescription: string;
    public backOrderEstDate: string;
    public initiateReturn: string;
    public exchangeItems: string;
    public items: string;
    public shipping: CmsShipping;
    public orderDetailFail: string;
    public tax: CmsTax;
    public orderItemDevice: CmsOrderItemDevice;
    public creditCard: CmsCreditCard;
    public byodDevice: CmsByodDevice;
    public upgradeFeeLabel: string;
    public upgradeFeeAlertData: AlertModalData;
    public unlimitedTalkText: CmsUnlimitedTalkText;
    public planGroupData: CmsPlanGroupData[];
    public totalHeader: string;
    public ndelOrUpgradeHeader: string;
    public parentOrderDescription: string;
    public promotionHeader: string;
    public promotionConfirmation: string;
    public promotionConfirmationBOID: string;
}
